package com.devi3east.bashbuddy.features.common.util

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.datetime.*

@Composable
fun ModernTimePicker(
    initialInstant: Instant?,
    onTimeSelected: (Instant) -> Unit,
    onDismiss: () -> Unit
) {
    // ----------------------------------
    // Time zone used for display & conversion
    // ----------------------------------
    val timeZone = TimeZone.currentSystemDefault()

    // ----------------------------------
    // Resolve initial date
    // ----------------------------------
    val initialDateTime = initialInstant
        ?.toLocalDateTime(timeZone)

    val date = initialDateTime?.date
        ?: Clock.System.now().toLocalDateTime(timeZone).date

    // ----------------------------------
    // Defaults: 10:00 AM
    // ----------------------------------
    val defaultHour24 = 10
    val defaultMinute = 0

    val initialHour24 = initialDateTime?.hour ?: defaultHour24
    val initialMinute = initialDateTime?.minute ?: defaultMinute

    // ----------------------------------
    // Convert 24h → 12h
    // ----------------------------------
    var hour by remember {
        mutableStateOf(
            when {
                initialHour24 == 0 -> 12
                initialHour24 > 12 -> initialHour24 - 12
                else -> initialHour24
            }
        )
    }

    var minute by remember { mutableStateOf(initialMinute) }
    var isAm by remember { mutableStateOf(initialHour24 < 12) }

    // ----------------------------------
    // UI
    // ----------------------------------
    AlertDialog(
        onDismissRequest = onDismiss,
        text = {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxWidth()
            ) {
                Row(
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SimpleNumberPicker(
                        value = hour,
                        range = 1..12,
                        onValueChange = { hour = it }
                    )

                    Text(":", fontSize = 28.sp)

                    SimpleNumberPicker(
                        value = minute,
                        range = 0..59,
                        onValueChange = { minute = it }
                    )
                }

                Spacer(Modifier.height(16.dp))

                Row(
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FilterChip(
                        selected = isAm,
                        onClick = { isAm = true },
                        label = { Text("AM") }
                    )

                    Spacer(Modifier.width(8.dp))

                    FilterChip(
                        selected = !isAm,
                        onClick = { isAm = false },
                        label = { Text("PM") }
                    )
                }
            }
        },
        confirmButton = {
            Button(
                onClick = {
                    // ----------------------------------
                    // Convert 12h → 24h
                    // ----------------------------------
                    val hour24 = when {
                        isAm && hour == 12 -> 0
                        !isAm && hour != 12 -> hour + 12
                        else -> hour
                    }

                    // ----------------------------------
                    // Build LocalDateTime → Instant
                    // ----------------------------------
                    val localDateTime = LocalDateTime(
                        date = date,
                        time = LocalTime(hour24, minute)
                    )

                    val finalInstant = localDateTime.toInstant(timeZone)

                    onTimeSelected(finalInstant)
                    onDismiss()
                }
            ) {
                Text("OK")
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text("Cancel")
            }
        }
    )
}